type TAnalyticsIssue = TIssue | TBecIssueRow | TFraudDefenseTableRow

type TIssueAnalyticsProps = {
    issueId: string
    issueType: TIssueType | TIssueCategory
    issueName: string
    severity: TIssueSeverity
    issueStatus: TIssueStatus
    issueDate?: string
    findingName?: string
}

const isFdTableRow = (
    issue: TAnalyticsIssue
): issue is TFraudDefenseTableRow => 'issueCategory' in issue

export const getIssueAnalyticsProps = (
    issue: TAnalyticsIssue,
    overrides?: Partial<TIssueAnalyticsProps>
): TIssueAnalyticsProps => ({
    issueId: issue.id,
    issueType: isFdTableRow(issue) ? issue.issueCategory : issue.issue_type,
    issueName: isFdTableRow(issue) ? issue.issueName : issue.name,
    severity: issue.severity,
    issueStatus: issue.status,
    issueDate: isFdTableRow(issue) ? issue.emailTime : issue.created_at,
    ...overrides,
})
